import zod from 'zod';
import { zodLimit, zodPage } from './helpers';

export const SignaturesSchemas = {
    Signatures: zod.object({
        page: zodPage,
        limit: zodLimit(),
    }),
};
